import { useMemo } from 'react';

interface ChargeCalculationResult {
	formattedPurchaseAmount: string;
	formattedSurchargeAmount: string;
	formattedTotalCharge: string;
}

export const useChargeFormatter = (
	purchaseAmount: number = 0,
	surchargeAmount: number = 0,
	totalAmount: number = 0,
	currency: string = 'USD',
	locale: string = 'en-US'
): ChargeCalculationResult => {
	const currencyFormatter = useMemo(() => {
		return new Intl.NumberFormat(locale, {
			style: 'currency',
			currency: currency,
		});
	}, [locale, currency]);

	const calculations = useMemo(() => {
		return {
			formattedPurchaseAmount: currencyFormatter.format(purchaseAmount),
			formattedSurchargeAmount: currencyFormatter.format(surchargeAmount),
			formattedTotalCharge: currencyFormatter.format(totalAmount),
		};
	}, [purchaseAmount, surchargeAmount, totalAmount, currencyFormatter]);

	return { ...calculations };
};
